import { create } from "zustand";
import { persist } from "zustand/middleware";

interface User {
  user_id?: number;
  user_first_name?: string;
  user_last_name?: string;
  user_mobile?: string;
  user_avatar?: string;
  user_role?: string;
}

interface UserStoreState {
  user: User | null;
  token: string | null;
  lastUpdateTime: number;
  addUser: (newUser: User, token: string) => void;
  deleteUser: () => void;
  updateUser: (update: Partial<User>) => void;
}

const TWELVE_HOURS = 12 * 60 * 60 * 1000;

/**
 * متغیرهای کمکی (global) که یک‌بار در زمان ساخت استور پر می‌شوند
 */
let externalSet: any;
let externalGet: any;

const useUserStore = create<UserStoreState>()(
  persist(
    (set, get) => {
      // در بدنه‌ی اصلی استور، set و get را در متغیرهای بالایی ذخیره می‌کنیم
      externalSet = set;
      externalGet = get;

      return {
        user: null,
        token: null,
        lastUpdateTime: 0,

        addUser: (newUser, token) => {
          set({
            user: newUser,
            token,
            lastUpdateTime: Date.now(),
          });
        },

        deleteUser: () => {
          set({
            user: null,
            token: null,
            lastUpdateTime: Date.now(),
          });
        },

        updateUser: (update) => {
          set((state) => ({
            user: { ...state.user, ...update },
            lastUpdateTime: Date.now(),
          }));
        },
      };
    },
    {
      name: "myUser",
      onRehydrateStorage: () => {
        // برمی‌گرداند تابعی که پس از بازیابی state از استوریج صدا زده می‌شود
        return (state, error) => {
          if (error) {
            console.error("Error rehydrating:", error);
            return;
          }
          if (!state) return;

          const now = Date.now();
          if (now - state.lastUpdateTime > TWELVE_HOURS) {
            // به جای this.getState() یا useUserStore.getState() از externalSet استفاده می‌کنیم
            externalSet({
              user: null,
              token: null,
              lastUpdateTime: Date.now(),
            });
          }
        };
      },
    }
  )
);

export default useUserStore;
